import axios from "axios";

export default axios.create({
  baseURL: window.__pixelConfig.APP_MEDIA_SERVER,
});
